// Address service for API calls
import { AddressResponse } from '../types';
import { fetchWithErrorHandling, guestPrefix } from './apiUtils';

export class AddressService {
  static async getUserAddresses(userId: number): Promise<AddressResponse> {
    try {
      // Try API first
      try {
        const endpoint = `/api/v2${guestPrefix()}/users/${userId}/addresses`;
        return await fetchWithErrorHandling<AddressResponse>(endpoint);
      } catch (apiError) {
        console.warn('API not available, falling back to local data:', apiError);

        // Fall back to local JSON file
        try {
          const { default: localAddressData } = await import('../data/addresses.sample.data.json');
          return localAddressData as AddressResponse;
        /* c8 ignore start */
        } catch (localError) {
          console.error('Failed to load local address data:', localError);
          throw new Error('Unable to load address data from both API and local data.');
        }
        /* c8 ignore stop */
      }
    /* c8 ignore start */
    } catch (error) {
      console.error('Failed to fetch address data:', error);
      throw new Error('Unable to load address data. Please try again later.');
    }
    /* c8 ignore stop */
  }
}
